/* eslint-disable react/prop-types */
import React from "react";
import "../../assets/styles/App.css";
import "./CustomDeviceSearchModal.css";
import { Button, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getDeviceBySerial,
  removeDeviceFromSiteForService
} from "../../constants/endpoints";
import { getAuthenticatedData, putAuthenticatedData } from "../../utils/async";
import { withTranslation } from "react-i18next";
import { T_SERVICE } from "../../constants/translations";

const INITIAL_STATE = {
  serial: "",
  isSearching: false,
  searched: false,
  device: null,
  confirming: false,
  isUnlinking: false
};

/**
 * Modal that lets a SERVICE user search for a device by its serial number and unlink
 * it from whichever site it is currently attached to (a global, cross-site operation).
 *
 * @component
 */
class CustomDeviceSearchModal extends React.Component {
  constructor(props) {
    super(props);
    this.t = props.t;
    this.i18n = props.i18n;

    this.state = { ...INITIAL_STATE };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleUnlink = this.handleUnlink.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    this.handleSearch();
  }

  handleSearch() {
    const serial = this.state.serial.trim();
    if (!serial) {
      return;
    }
    this.setState({
      isSearching: true,
      confirming: false,
      isUnlinking: false
    });
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getDeviceBySerial +
        "/" +
        encodeURIComponent(serial)
    ).then(
      result => {
        this.setState({
          isSearching: false,
          searched: true,
          device: result?.data || null
        });
      },
      () => {
        this.setState({ isSearching: false, searched: true, device: null });
      }
    );
  }

  handleUnlink() {
    const device = this.state.device;
    if (!device) {
      return;
    }
    // First click arms the confirmation, second click unlinks.
    if (!this.state.confirming) {
      this.setState({ confirming: true });
      return;
    }

    this.setState({ isUnlinking: true });
    putAuthenticatedData(
      sessionStorage.getItem("domain") +
        removeDeviceFromSiteForService +
        "/" +
        device.id,
      {}
    )
      .then(result => {
        if (result.status === 200) {
          toast.success(this.t(T_SERVICE.toast.deviceUnlinkedSuccessfully));
          if (this.props.resetList) {
            this.props.resetList();
          }
          // Reset the form back to its initial state after a successful unlink.
          this.setState({ ...INITIAL_STATE });
        } else {
          this.setState({ isUnlinking: false, confirming: false });
        }
        return result.json();
      })
      .then(resp => {
        if (
          resp?.status?.statusCode !== "OK" &&
          resp?.status?.statusCode !== "FORBIDDEN" &&
          resp?.status?.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp?.status?.message);
        }
      });
  }

  renderResult() {
    const {
      device,
      searched,
      isSearching,
      confirming,
      isUnlinking
    } = this.state;

    if (isSearching) {
      return null;
    }
    if (!searched) {
      return (
        <p className="device-search-hint">
          {this.t(T_SERVICE.findDevice.prompt)}
        </p>
      );
    }
    if (!device) {
      return (
        <p className="device-search-notfound">
          {this.t(T_SERVICE.findDevice.notFound)}
        </p>
      );
    }

    return (
      <div className="device-search-result">
        <div className="device-search-field">
          <span className="field-label">
            {this.t(T_SERVICE.findDevice.serialNumber)}
          </span>
          <span className="field-value">{device.serialNumber}</span>
        </div>
        <div className="device-search-field">
          <span className="field-label">
            {this.t(T_SERVICE.findDevice.deviceType)}
          </span>
          <span className="field-value">{device.deviceType}</span>
        </div>
        <div className="device-search-field">
          <span className="field-label">
            {this.t(T_SERVICE.findDevice.attachedSite)}
          </span>
          {device.siteId ? (
            <span className="field-value">{device.siteName}</span>
          ) : (
            <span className="field-value unattached">
              {this.t(T_SERVICE.findDevice.notAttached)}
            </span>
          )}
        </div>

        {device.siteId ? (
          <div className="device-search-actions">
            <Button
              className="device-search-unlink-btn"
              disabled={isUnlinking}
              onClick={this.handleUnlink}
            >
              {isUnlinking
                ? "..."
                : confirming
                ? this.t(T_SERVICE.findDevice.confirmUnlink)
                : this.t(T_SERVICE.findDevice.unlink)}
            </Button>
            <p className="device-search-warning">
              {this.t(T_SERVICE.findDevice.unlinkWarning)}
            </p>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { isSearching, serial } = this.state;

    return (
      <div className="custommodal">
        <div className="custommodalinner device-search-modal">
          <div className="loginpad">
            <h6 className="modal-heading">
              {this.t(T_SERVICE.findDevice.header)}
            </h6>
            <Button onClick={this.props.closePopup} className="cancle">
              x
            </Button>
            <hr className="hrpadding" />
            <div className="firstpage">
              <form onSubmit={this.onSubmit}>
                <label className="device-search-label">
                  {this.t(T_SERVICE.findDevice.serialLabel)}
                </label>
                <div className="device-search-row">
                  <FormControl
                    autoFocus
                    type="text"
                    name="serial"
                    value={serial}
                    onChange={e => this.setState({ serial: e.target.value })}
                    placeholder={this.t(T_SERVICE.findDevice.serialPlaceholder)}
                  />
                  <Button
                    type="submit"
                    className="loginbtn1 device-search-search-btn"
                    disabled={isSearching || !serial.trim()}
                  >
                    {this.t(T_SERVICE.findDevice.search)}
                  </Button>
                </div>
              </form>

              {this.renderResult()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomDeviceSearchModal);
